<template>
  <ion-page style="justify-content: flex-start;">
    <ion-content :fullscreen="true">
      <div class="toolbar" style="position: relative; width: 100%; height: 50px; display: flex; justify-content: space-between; align-items: center; background-color: #F6F4F3 !important; z-index: 1000;">
        <div class="buttons" style="display: flex; justify-content: flex-start; align-items: center; margin-right: auto; height: 50px;">
          <ion-menu-button style="color: var(--topbar-icon-color);"></ion-menu-button>
          <ion-icon @click="goBack" class="text-20" :icon="chevronBack" style="color: black !important; margin: 0 5px; cursor: pointer;"></ion-icon>
        </div>
        <div class="logo" style="position: absolute; left: 50%; transform: translateX(-50%); height: 90%; display: grid; place-content: center;">
          <img :src="menuLogo" @error="handleImgError" style="max-height: 40px; padding: 5px 5px 0 5px; margin: 0 auto;" />
        </div>
        <!-- <div class="notification-icon" style="position: absolute; top: 50%; right: 0; transform: translateY(-50%);">
          <ion-icon :icon="notificationsOutline" class="text-20" style="color: white; margin: 0 20px; cursor: pointer;" @click="toggleNotificationModal"></ion-icon>
        </div> -->
      </div>
      
      <master-layout
      smallTitle="i tuoi"
      bigTitle="Ordini"
      titleStyle="horizontal"
      :showToolbar="false"
      :showMenu="false"
      :showBack="false"
      :showNotifications="false"
      :notificationList="notificationList"
      :showProfilePic="true"
    >
      <ListaOrdiniSenzaCalendario v-if="mode"></ListaOrdiniSenzaCalendario>
      <ListaOrdiniConCalendario v-else></ListaOrdiniConCalendario>
    <button
      v-if="mode"
      @click="toggleMode"
      class="fixed bottom center button-bottom-axerta-secondary w-75 text-16"
    >
      Modalità calendario
    </button>
    <button
      v-else
      @click="toggleMode"
      class="fixed bottom center button-bottom-axerta-secondary w-75 text-16"
    >
      Modalità lista
    </button>
  </master-layout>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import { IonMenuButton, IonIcon, IonPage, IonContent } from "@ionic/vue"
import { homeOutline, notificationsOutline, chevronBack } from "ionicons/icons"
import ListaOrdiniSenzaCalendario from "./ListaOrdiniSenzaCalendario.vue"
import ListaOrdiniConCalendario from "./ListaOrdiniConCalendario.vue"
import ApiService from "../../common/service.api"

const router = useRouter()
const mode = ref(false)
const menuLogo = ref('')
const showNotificationModal = ref(false)

function toggleMode() {
  mode.value = !mode.value
}

function goHome() {
  router.push("/")
}

function goBack() {
  router.go(-1)
}

function toggleNotificationModal() {
  showNotificationModal.value = !showNotificationModal.value
}

function handleImgError(event) {
  event.target.src = "https://placehold.co/300x300?text=MartechRevolution"
}

async function getLogo() {
  const companyId = localStorage.getItem("companyId")
  if (!companyId) return

  try {
    let res = await ApiService.get(`/AppSetting/${companyId}`)
    menuLogo.value = res.data.LogoApp
  } catch (error) {
    console.error("Error", error)
  }
}

const notificationList = ref([])
const loadingNotificationList = ref(false)

function getNotificationList() {
  loadingNotificationList.value = true
  ApiService.get(`Notification/GetUserNotification`)
    .then((res) => {
      notificationList.value = res.data
    })
    .finally(() => {
      loadingNotificationList.value = false
    })
}

onMounted(() => {
  getLogo()
  getNotificationList()
})
</script>

<style scoped>
ion-content {
  --background: #ffffff !important;
}

ion-page {
  --background: #ffffff !important;
  background: #ffffff !important;
}

::v-deep .master-layout-header {
  background: transparent !important;
}

::v-deep #container_normal {
  background: #ffffff !important;
}
</style>
